import { render, staticRenderFns } from "./CurrentReservation.vue?vue&type=template&id=6f86875d&scoped=true&"
import script from "./CurrentReservation.vue?vue&type=script&lang=js&"
export * from "./CurrentReservation.vue?vue&type=script&lang=js&"
import style0 from "./CurrentReservation.vue?vue&type=style&index=0&id=6f86875d&prod&lang=scss&scoped=true&"
import style1 from "./CurrentReservation.vue?vue&type=style&index=1&id=6f86875d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f86875d",
  null
  
)

export default component.exports